import { render } from "./TrainingCourse.vue?vue&type=template&id=3fd87fc1&scoped=true&ts=true"
import script from "./TrainingCourse.vue?vue&type=script&lang=ts"
export * from "./TrainingCourse.vue?vue&type=script&lang=ts"

import "./TrainingCourse.vue?vue&type=style&index=0&id=3fd87fc1&lang=css"
import "./TrainingCourse.vue?vue&type=style&index=1&id=3fd87fc1&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd87fc1"]])

export default __exports__